import React from "react"
import InterventiStore from "../interventiStore"
import { YearSelector } from "../../common/components/yearSelector"
import { Link } from "../../common/components/link"
import { links } from "../../routes"
import DatesHelper from "../../common/datesHelper"
import { Loading } from "../../common/components/loading"
import { confirmMessage, messageAlert } from "../../common/components/confirm"
import { InterventoDto } from "../../generated"
import InterventiActions from "../InterventiActions"
import { orderBy, take } from "lodash"
import { TechnicianViewer } from "../../technicians/components/TechnicianViewer"
import { ImpiantoLightDataComponent } from "../../impianti/components/impiantoLightData"

export const InterventoChecksLabels: React.FunctionComponent<{ intervento: InterventoDto }> = ({ intervento }) => {
    return (
        <div className="d-flex flex-wrap">
            {intervento.controlloStandard && <span className="badge bg-info m-1">Manutenzione</span>}
            {intervento.controlloCombustione && <span className="badge bg-warning m-1">Fumi</span>}
            {intervento.applicazioneBollino && <span className="badge bg-success m-1">Bollino</span>}
            {intervento.rapportoControlloId && <span className="badge bg-success m-1">Rapp.Controllo</span>}
        </div>
    )
}

const InterventoListItem: React.FunctionComponent<{ intervento: InterventoDto, onDelete: (intervento: InterventoDto) => void }> = ({ intervento, onDelete }) => {
    return (
        <div key={intervento.idIntervento} className="d-flex">
            <Link to={links.interventoEdit(intervento.idCliente!, intervento.idIntervento)} className="list-group-item list-group-item-action">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex flex-wrap">
                        <span className="badge bg-primary me-2" style={{ fontSize: "1rem" }}>
                            {DatesHelper.getReadableDateString(intervento.dataIntervento)}
                        </span>
                        {intervento.idImpianto &&
                            <div>
                                <ImpiantoLightDataComponent id={intervento.idImpianto} idCliente={intervento.idCliente}
                                    template={impianto => <div>{impianto.marca} {impianto.modello}</div>}
                                />
                            </div>}
                    </div>
                    <div style={{ fontSize: "0.9rem" }} className="text-uppercase">
                        <strong>{intervento.tipoIntervento.descTipoIntervento}</strong>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div style={{ fontSize: "0.8rem" }}>
                        <span>{intervento.oggettoIntervento}</span>
                        {intervento.idTechnician && <span className="ms-3">
                            <TechnicianViewer
                                id={intervento.idTechnician}
                                template={t => <>
                                    <span><i className="fas fa-circle" style={{ color: t.color }} /> {`${t.firstName} ${t.lastName}`} </span>
                                </>} />
                        </span>}
                    </div>
                    <InterventoChecksLabels intervento={intervento} />
                </div>
            </Link>
            <div className="p-1">
                <button className="btn btn-outline-danger btn-sm h-100"
                    style={{ width: 35 }}
                    onClick={() => onDelete(intervento)}><i className="fas fa-trash" />
                </button>
            </div>
        </div>
    )
}

export const InterventiClienteWidget = (props: { idCliente: number, style?: React.CSSProperties }) => {
    const currentYear = new Date().getFullYear();
    const [year, setYear] = React.useState<number | null>(null);
    const allInterventi = InterventiStore.useForCliente(props.idCliente);
    const interventi = year
        ? allInterventi?.filter(x => x.dataIntervento.getFullYear() >= year && x.dataIntervento.getFullYear() <= year)
        : take(orderBy(allInterventi, x => x.dataIntervento, ["desc"]), 5);

    const onDeleteIntervento = async (intervento: InterventoDto) => {
        if (await confirmMessage(`Sei sicuro di voler eliminare l'intervento ${intervento.oggettoIntervento} del ${DatesHelper.getReadableDateString(intervento.dataIntervento)}?`, "Elimina intervento")) {
            let result = await InterventiActions.delete(intervento.idCliente, intervento.idIntervento);
            if (!result.deleteOk) {
                messageAlert("Si sono verificati dei problemi in fase di eliminazione dell'intervento. Contattare l'assistenza.", "Elimina intervento")
            }
        }
    }

    return (
        <div className="card">
            <div className="card-header bg-secondary d-flex justify-content-between align-items-center">
                <h3 className="text-white"><i className="fas fa-truck me-2" /> Storico Interventi</h3>
                <div style={{ maxWidth: 150 }}>
                    <YearSelector
                        placeholder="ULTIMI 5"
                        selectedYear={year}
                        onChange={year => setYear(year)}
                        minYear={2012}
                        maxYear={currentYear}
                        allowNulls
                    />
                </div>
            </div>
            <div className="card-body" style={{ padding: 0 }}>
                {interventi
                    ? <ul className="list-group" style={{ overflowY: "auto", maxHeight: 250 }}>
                        {interventi.map(i => <InterventoListItem key={i.idIntervento} intervento={i} onDelete={onDeleteIntervento} />)}
                        {interventi.length === 0 && <div className="w-100 text-center">
                            <div><i className="fas fa-ellipsis-h fa-3x text-gray" /></div>
                            <div>Nessun intervento nel {year}</div>
                        </div>}
                    </ul>
                    : <Loading />}
            </div>
            <div className="card-footer">
                <Link to={links.interventoNew({ idCliente: props.idCliente })} className="btn btn-outline-secondary">
                    <i className="fas fa-plus" /> <i className="fas fa-truck" /> Nuovo Intervento
                </Link>
            </div>
        </div>
    );
}